import { bsClassJustifyContent } from '@common/types/bootstrap';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import React, { PropsWithChildren } from 'react';
import { Form } from 'react-bootstrap';

interface IFormGroupProps {
    controlId: string,
    controlLabel: string,
    reverseLabel?: boolean,
    controlLabelRowJustifyClass?: bsClassJustifyContent,
    controlLabelTailElement?: JSX.Element,
    helpId?: string,
    helpText?: string
    errorId: string
    errorMessage?: string
    className?: string
}

const RenderLabel = (controlId: string, label: string, justifyClass: bsClassJustifyContent, controlLabelTailElement?: JSX.Element) => {
    if (controlLabelTailElement) {
        return (
            <div className={classNames("d-flex flex-row", justifyClass)}>
                {!isEmpty(label) && <Form.Label htmlFor={controlId}>{label}</Form.Label>}
                {controlLabelTailElement}
            </div>
        )
    }
    else if (isEmpty(label)) {
        return (<></>)
    }
    else {
        return (<Form.Label htmlFor={controlId}>{label}</Form.Label>)
    }
}

export const FormGroup = ({ controlLabelRowJustifyClass = "justify-content-between", ...props }: PropsWithChildren<IFormGroupProps>) =>
    <Form.Group data-testid={props.controlId} className={props.className}>
        {!props.reverseLabel && RenderLabel(props.controlId, props.controlLabel, controlLabelRowJustifyClass, props.controlLabelTailElement)}
        {props.children}
        {props.reverseLabel && RenderLabel(props.controlId, props.controlLabel, controlLabelRowJustifyClass, props.controlLabelTailElement)}
        {props.helpText && <Form.Text id={props.helpId}>{props.helpText}</Form.Text>}
        <Form.Control.Feedback type="invalid">
            {props.errorMessage && <span role="alert" id={props.errorId}>{props.errorMessage}</span>}
        </Form.Control.Feedback>
    </Form.Group>
